import React, { useState, useEffect } from 'react'
import { Button } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'
import PlanCard from './components/PlanCard'
import { PLANS } from '../../constants/plans'
import PricingTable from 'components/PricingTable/PricingTable'
import { ALL_FEATURES, PRICING_FEATURES } from '../../constants/plans'
import { isIndia } from 'constants/currency'

import { LogoShowcase } from '../../Landing/Home/Home'

import styles from './PricingGrid.module.css'

const PricingGrid = ({ className, period, prices, onSubPlanClick, hideFreeCard, hideMaxCard, hideTable }) => {
  const [hideFreePlan, setHideFreePlan] = useState(hideFreeCard)
  const history = useHistory()

  useEffect(() => {
    setHideFreePlan(hideFreeCard)
  }, [hideFreeCard])

  return (
    <>
      <div className={`${className} ${styles.container} mb-2`}>
        <PlanCard
          plan={PLANS.TINY}
          planPrice={prices.tinyPlan}
          title={PLANS.TINY.label}
          subtitle="Perfect for a single, professional link"
          features={PRICING_FEATURES[PLANS.TINY.id]}
          period={period}
          ctaTheme="blue"
          onSubPlanClick={onSubPlanClick}
          hideCompareCTA={hideTable}
          dataTestId="PricingGrid-tiny-plan"
        />
        <PlanCard
          plan={PLANS.PRO}
          planPrice={prices.soloPlan}
          title={PLANS.PRO.label}
          subtitle="Great for individuals & small projects"
          features={PRICING_FEATURES[PLANS.PRO.id]}
          period={period}
          ctaTheme="purple"
          onSubPlanClick={onSubPlanClick}
          hideCompareCTA={hideTable}
          dataTestId="PricingGrid-solo-plan"
          popular
        />
        <PlanCard
          plan={PLANS.PRO_U}
          planPrice={prices.proPlan}
          title={PLANS.PRO_U.label}
          subtitle="For freelancers, agencies & companies"
          features={PRICING_FEATURES[PLANS.PRO_U.id]}
          period={period}
          ctaTheme="warning"
          onSubPlanClick={onSubPlanClick}
          hideCompareCTA={hideTable}
          dataTestId="PricingGrid-pro-plan"
        />
        {!hideMaxCard && (
          <PlanCard
            plan={PLANS.PRO_MAX}
            planPrice={prices.maxPlan}
            title={PLANS.PRO_MAX.label}
            subtitle="Designed for large files, creative projects & teams"
            features={PRICING_FEATURES[PLANS.PRO_MAX.id]}
            period={period}
            ctaTheme="dark"
            onSubPlanClick={onSubPlanClick}
            hideCompareCTA={hideTable}
            customStyles={{ maxHeight: '660px' }}
            dataTestId="PricingGrid-max-plan"
            badgeText={isIndia ? 'Up to 40% off' : 'Upload up to 2TB'}
            hideVisitorLimit
          />
        )}
      </div>
      <div className={styles.enterpriseContainer}>
        <div className={styles.enterpriseContent}>
          <span>Need something custom? Talk to us for enterprise plans</span>
        </div>
        <Button
          className={styles.enterpriseButton}
          size="sm"
          variant="outline-light"
          onClick={() => history.push('/contact-sales')}
        >
          Contact sales
        </Button>
      </div>
      {!hideTable && (
        <>
          <LogoShowcase title="Do more with your links" className="mt-2 mb-5" />
          <PricingTable plans={PLANS} prices={prices} period={period} featureList={ALL_FEATURES} history={history} />
        </>
      )}
    </>
  )
}

export default PricingGrid
